import React from 'react';
import { Text, Icon } from '@lana-ui/common';
import { ConfirmacionLogin } from '@lana-ui/login';
import ConfirmacionConTarjetaClub from '@images/confirmacionConTarjetaClub';
import ConfirmacionSinTarjetaClub from '@images/confirmacionSinTarjetaClub';
import { useStore } from '../../Store/storeProvider';
import '@styles/Components/Cierre.scss';

const Cierre = ({
    title,
    cardType,
    firstBtnLabel,
    secondBtnLabel,
    onClickCierre,
    secondBtnOnClick,
    validarPin,
    hasSuscripDigital,
}) => {
    const { Config } = useStore();

    return (
        <div className="cierre">
            {(cardType === 'P' || cardType === 'B' || validarPin) && (
                <ConfirmacionLogin
                    titleText={title}
                    image={
                        <ConfirmacionConTarjetaClub
                            width="201.24"
                            height="160"
                        />
                    }
                    firstBtnLabel={
                        hasSuscripDigital ? 'Finalizar' : firstBtnLabel
                    }
                    firstBtnOnClick={() =>
                        hasSuscripDigital
                            ? (window.location.href = Config.URLCallback)
                            : onClickCierre()
                    }
                    secondBtnLabel={!hasSuscripDigital && secondBtnLabel}
                    secondBtnOnClick={() =>
                        !secondBtnOnClick
                            ? (window.location.href = Config.URLCallback)
                            : secondBtnOnClick()
                    }
                >
                    <Text as="p" size="--twoxs" className="con-tarjeta-club">
                        {validarPin && (
                            <span className="--mb-16">
                                A partir de ahora podés:
                            </span>
                        )}

                        {hasSuscripDigital ? (
                            <span className="--mb-16">Ya podés:</span>
                        ) : (
                            <div className="--mb-16">
                                Tu credencial de{' '}
                                <span className="ln">Club LA NACION</span> te
                                brinda una{' '}
                                <strong>suscripción digital sin cargo</strong>.
                                Activala y podrás:
                            </div>
                        )}

                        <div>
                            <span>
                                <Icon name="checkmark" />
                                Acceder a las notas sin límite mensual
                            </span>
                            <span>
                                <Icon name="checkmark" />
                                Acceder a notas exclusivas
                            </span>
                            <span>
                                <Icon name="checkmark" />
                                Acceder a la edición impresa en pdf y a las{' '}
                                revistas
                            </span>
                        </div>
                    </Text>
                </ConfirmacionLogin>
            )}

            {(cardType === 'C' || cardType === '') && (
                <ConfirmacionLogin
                    titleText={title}
                    image={
                        <ConfirmacionSinTarjetaClub
                            width="201.24"
                            height="160"
                        />
                    }
                    firstBtnLabel="Finalizar"
                    showCallbackArticle
                    firstBtnOnClick={() =>
                        (window.location.href = Config.URLCallback)
                    }
                >
                    <Text size="--twoxs" className="sin-tarjeta-club">
                        Ya podés configurar y recibir los titulares de tus temas{' '}
                        de interés en tu casilla de email y asociar tu cuenta a{' '}
                        Facebook y Google.
                    </Text>
                </ConfirmacionLogin>
            )}
        </div>
    );
};

export default Cierre;
